import script from "./HandleCompose.vue?vue&type=script&setup=true&lang=js"
export * from "./HandleCompose.vue?vue&type=script&setup=true&lang=js"

import "./HandleCompose.vue?vue&type=style&index=0&id=72d70105&lang=css"

const __exports__ = script;

export default __exports__